/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum QueryKeys {
  // organization page
  fetchDashboardForOrganization = 'fetchDashboardForOrganization',
  // manage organization
  fetchOrganizationById = 'fetchOrganizationById',
  fetchOrganizationUsers = 'fetchOrganizationUsers',
  fetchOrganizationInvitations = 'fetchOrganizationInvitations',
  fetchOrganizationRegistrationInvitations = 'fetchOrganizationRegistrationInvitations',
  fetchOidcConfiguration = 'fetchOidcConfiguration',
  // cluster page
  fetchClusterDetails = 'fetchClusterDetails',
  fetchClusterStatus = 'fetchClusterStatus',
  fetchClusterUpgradeStatus = 'fetchClusterUpgradeStatus',
  fetchClusterDatabaseSchemas = 'fetchClusterDatabaseSchemas',
  fetchPgHbaOfCluster = 'fetchPgHbaOfCluster',
  fetchDatabaseListOfCluster = 'fetchDatabaseListOfCluster',
  fetchUserListOfCluster = 'fetchUserListOfCluster',
  fetchParametersOfCluster = 'fetchParametersOfCluster',
  fetchNodeListOfCluster = 'fetchNodeListOfCluster',
  fetchNodeLogsOfCluster = 'fetchNodeLogsOfCluster',
  fetchClusterLogicalBackups = 'fetchClusterLogicalBackups',
  fetchClusterBackupsHistory = 'fetchClusterBackupsHistory',
  fetchCredentialsOfCluster = 'fetchCredentialsOfCluster',
  fetchCredentialsOfClusterCypex = 'fetchCredentialsOfClusterCypex',
  fetchStorageOfCluster = 'fetchStorageOfCluster',

  // teams
  fetchTeams = 'fetchTeams',
  fetchTeam = 'fetchTeam',
  fetchSsoGroups = 'fetchSsoGroups',

  // project page
  fetchProject = 'fetchProject',
  fetchProducts = 'fetchProducts',
  fetchCluster = 'fetchCluster',
  fetchClusters = 'fetchClusters',
  fetchDeepthinkerLatestRuntime = 'fetchDeepthinkerLatestRuntime',
  fetchDeepthinkerRunStatus = 'fetchDeepthinkerRunStatus',
  fetchAdvice = 'fetchAdvice',
  fetchDismissedAdvice = 'fetchDismissedAdvice',
  fetchClusterContinuousBackups = 'fetchClusterContinuousBackups',

  // premise
  fetchAllActiveUsers = 'fetchAllActiveUsers',

  fetchDashboardForUser = 'fetchDashboardForUser',
  fetchProjectsOfOrganization = 'fetchProjectsOfOrganization',
  fetchProjectsWithClusters = 'fetchProjectsWithClusters',
  fetchUserServices = 'fetchUserServices',

  fetchDatasets = 'fetchDatasets',
  fetchDatasetImports = 'fetchDatasetImports',
  // superuser
  fetchSystemConfiguration = 'fetchSystemConfiguration',

  adminFetchUsers = 'adminFetchUsers',
  adminFetchPlans = 'adminFetchPlans',
  fetchAdminJiraConfig = 'fetchAdminJiraConfig',

  fetchAdminDatasets = 'fetchAdminDatasets',
  fetchAdminDatasetsCategories = 'fetchAdminDatasetsCategories',
  adminFetchOrganizations = 'adminFetchOrganizations',
  adminFetchOrphans = 'adminFetchOrphans',

  fetchLogicalBackupStatus = 'fetchLogicalBackupStatus',

  fetchContinuousBackupLatestRestorePoint = 'fetchContinuousBackupLatestRestorePoint',
  fetchContinuousBackupOldestRestorePoint = 'fetchContinuousBackupOldestRestorePoint',

  // support plans
  fetchSupportPlans = 'fetchSupportPlans',

  // jira support
  fetchJiraRequestTypes = 'fetchJiraRequestTypes',
  fetchJiraRequestTypeFields = 'fetchJiraRequestTypeFields',
  fetchJiraRequests = 'fetchJiraRequests',
  fetchJiraRequest = 'fetchJiraRequest',
  fetchJiraRequestComments = 'fetchJiraRequestComments',
  fetchJiraConfig = 'fetchJiraConfig',
  fetchAdminJiraTickets = 'fetchAdminJiraTickets',

  // postgres versions,
  fetchPostgresVersions = 'fetchPostgresVersions',

  // system
  fetchSystemStatus = 'fetchSystemStatus',
  // storage classes
  fetchStorageClasses = 'fetchStorageClasses',

  // setup
  fetchSetupProgress = 'fetchSetupProgress',
}
